import { CellContext } from "@tanstack/react-table";
import { RowExpansion } from "@design-system/ViewTable/RowExpansion";
import classNames from "classnames";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import tableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { ClientDetailsRow } from "../clientViewConfig";
import styles from "../ClientsView.module.scss";
import { ClientActionsDropdown } from "../../ClientActionsDropdown/ClientActionsDropdown";
import { EntityActionsDropdown } from "../../EntityActionsDropdown/EntityActionsDropdown";
import { useOpenClientWorkspace } from "../../useOpenClientWorkspace";

export const ActionsCell = ({
    row,
}: CellContext<ViewTableFeatures, ClientDetailsRow, unknown>) => {
    const openClientWorkspace = useOpenClientWorkspace();

    const workspace = row.getParentRow()?.original ?? row.original;

    if (!workspace) {
        return null;
    }

    if (row.original.type === "entity") {
        const entity = row.original;
        return (
            <ViewTableCell
                captureClicks
                className={classNames(styles.actions, tableStyles.showOnHover)}
            >
                <EntityActionsDropdown
                    entity={{
                        id: Number(entity.id),
                        name: entity.name,
                        members: entity.members ?? [],
                        isBusiness: entity.isBusiness === true,
                    }}
                    clientId={workspace.id}
                />
            </ViewTableCell>
        );
    }

    return (
        <ViewTableCell captureClicks className={styles.actions}>
            <RowExpansion row={row}>
                {(isExpanded) => (
                    <Button
                        variant="primary"
                        size="sm"
                        className={classNames({
                            [tableStyles.showOnHover]: !isExpanded,
                        })}
                        onClick={() => openClientWorkspace(workspace.id)}
                    >
                        Open
                    </Button>
                )}
            </RowExpansion>

            <div className={tableStyles.showOnHover}>
                <ClientActionsDropdown client={workspace} />
            </div>
        </ViewTableCell>
    );
};
